import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 쿠키 가져오기
 * @returns {Promise<axios.AxiosResponse<any>>}
 * @constructor
 */
const GetCookie =()=>{
    return customAxios.get(myIpAddress+'/auth/getCookie');
}
export default GetCookie;